import React from 'react';
import { Stethoscope, Check, Clock, AlertTriangle } from 'lucide-react';

// Tiny presentational pill showing a lead's OpenDental sync status.
// Rendered next to a lead's name in the pipeline / lead detail. Purely
// presentational — no data fetching, no side effects. Unknown / 'none'
// / undefined statuses render nothing so callers can drop it in
// unconditionally.
const STATUS_META = {
  synced: {
    cls: 'bg-green-100 text-green-700',
    Icon: Check,
    label: 'OpenDental',
    LeadIcon: Stethoscope,
  },
  pending: {
    cls: 'bg-amber-100 text-amber-700',
    Icon: Clock,
    label: 'Sync pending',
  },
  failed: {
    cls: 'bg-red-100 text-red-700',
    Icon: AlertTriangle,
    label: 'Sync failed',
  },
};

// `syncedLabel` replaces "OpenDental" where the column already says so
// (the Customers list shows "Booked").
const OpenDentalSyncBadge = ({ status, className = '', syncedLabel }) => {
  const meta = STATUS_META[status];
  if (!meta) return null;

  const { cls, Icon, LeadIcon } = meta;
  const label = status === 'synced' && syncedLabel ? syncedLabel : meta.label;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${cls} ${className}`}
    >
      {LeadIcon ? <LeadIcon size={12} /> : null}
      <Icon size={12} />
      {label}
    </span>
  );
};

export default OpenDentalSyncBadge;
